import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';
import { useUser } from '../UserContext';

function MemberPennants() {
  const { memberData } = useUser();

  if (!memberData) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="h6">Loading pennants and rankings...</Typography>
      </Box>
    );
  }

  const { pennants, rankings } = memberData;

  return (
    <Box sx={{ py: 4 }}>
      <Typography variant="h6" gutterBottom>
        Current Pennants
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 4 }}>
        {pennants && pennants.length > 0 ? (
          pennants.map((pennant, index) => (
            <Chip
              key={index}
              label={`${pennant.sport ? `${pennant.sport} ` : ''}${pennant.name || ''}`.trim()}
              sx={{ mr: 1, mb: 1 }}
            />
          ))
        ) : (
          <Typography variant="body2">No pennants listed.</Typography>
        )}
      </Box>

      <Typography variant="h6" gutterBottom>
        Rankings
      </Typography>
      {rankings && Object.keys(rankings).length > 0 ? (
        Object.entries(rankings).map(([event, rank], index) => (
          <Typography key={index} variant="body2">
            {event}: {rank}
          </Typography>
        ))
      ) : (
        <Typography variant="body2">No rankings available.</Typography>
      )}
    </Box>
  );
}

MemberPennants.propTypes = {
  memberData: PropTypes.object,
};

export default MemberPennants;
